import axios from "axios";
import * as constants from "./constants";
export var extractSystem = function (raw, overwrites) {
    var rv = [];
    if (!raw.monit || !raw.monit.service)
        return rv;
    raw.monit.service.forEach(function (s) {
        try {
            if (s.$.type === "5") {
                var name = s.name[0];
                var sys = s.system ? s.system[0] : null;
                if (!sys) {
                    rv.push({
                        name: name,
                        cpu_system: 0, cpu_user: 0, cpu_wait: 0,
                        load_avg01: 0, load_avg05: 0, load_avg15: 0,
                        memory_kb: 0, memory_percent: 0,
                        warn_cpu: false, warn_mem: false
                    });
                    return;
                }
                var SYSTEM_CPU_WARN_THRESHOLD_PERC = overwrites[name + "-cpu-warn-threshold-perc"] || constants.SYSTEM_CPU_WARN_THRESHOLD_PERC;
                var SYSTEM_MEM_WARN_THRESHOLD_PERC = overwrites[name + "-mem-warn-threshold-perc"] || constants.SYSTEM_MEM_WARN_THRESHOLD_PERC;
                var cpu_system = Number(sys.cpu[0].system[0]);
                var cpu_user = Number(sys.cpu[0].user[0]);
                var cpu_wait = Number(sys.cpu[0].wait[0]);
                var warn_cpu = cpu_system > SYSTEM_CPU_WARN_THRESHOLD_PERC ||
                    cpu_user > SYSTEM_CPU_WARN_THRESHOLD_PERC ||
                    cpu_wait > SYSTEM_CPU_WARN_THRESHOLD_PERC;
                var memory_percent = Number(sys.memory[0].percent[0]);
                var warn_mem = memory_percent > SYSTEM_MEM_WARN_THRESHOLD_PERC;
                rv.push({
                    name: name,
                    cpu_system: cpu_system,
                    cpu_user: cpu_user,
                    cpu_wait: cpu_wait,
                    load_avg01: Number(sys.load[0].avg01[0]),
                    load_avg05: Number(sys.load[0].avg05[0]),
                    load_avg15: Number(sys.load[0].avg15[0]),
                    memory_kb: Number(sys.memory[0].kilobyte[0]),
                    memory_percent: memory_percent,
                    warn_cpu: warn_cpu,
                    warn_mem: warn_mem
                });
            }
        }
        catch (e) {
            console.error("Failed to extract system data for service: " + (s.name ? s.name[0] : 'unknown'), e);
        }
    });
    return rv;
};
export var extractProcess = function (raw, overwrites) {
    var rv = [];
    if (!raw.monit || !raw.monit.service)
        return rv;
    raw.monit.service.forEach(function (s) {
        try {
            if (s.$.type === "3") {
                if (!s.pid) {
                    rv.push({
                        name: s.name[0],
                        pid: null
                    });
                    return;
                }
                var name = s.name[0];
                var PROCESS_CPU_WARN_THRESHOLD_PERC = overwrites[name + "-cpu-warn-threshold-perc"] || constants.PROCESS_CPU_WARN_THRESHOLD_PERC;
                var PROCESS_MEM_WARN_THRESHOLD_KB = overwrites[name + "-mem-warn-threshold-kb"] || constants.PROCESS_MEM_WARN_THRESHOLD_KB;
                var cpu = Number(s.cpu[0].percenttotal[0]);
                var memory_kb = Number(s.memory[0].kilobytetotal[0]);
                var uptime = Number(s.uptime[0]);
                var warn_cpu = cpu > PROCESS_CPU_WARN_THRESHOLD_PERC;
                var warn_mem = memory_kb > PROCESS_MEM_WARN_THRESHOLD_KB;
                var warn_uptime = uptime < constants.PROCESS_UPTIME_WARN_SECS;
                rv.push({
                    name: name,
                    pid: Number(s.pid[0]),
                    cpu: cpu,
                    memory_kb: memory_kb,
                    memory_percent: Number(s.memory[0].percenttotal[0]),
                    uptime: Number(s.uptime[0]),
                    warn_cpu: warn_cpu,
                    warn_mem: warn_mem,
                    warn_uptime: warn_uptime,
                });
            }
        }
        catch (e) {
            console.error("Failed to extract process data for service: " + (s.name ? s.name[0] : 'unknown'), e);
        }
    });
    return rv;
};
export var extractFilesystem = function (raw, overwrites) {
    var rv = [];
    if (!raw.monit || !raw.monit.service)
        return rv;
    raw.monit.service.forEach(function (s) {
        try {
            if (s.$.type === "0") {
                var name = s.name[0];
                if (s.status[0] !== "0") {
                    rv.push({
                        name: name,
                        status: false
                    });
                    return;
                }
                var FILESYSTEM_SPACE_THRESHOLD_PERC = overwrites[name + "-space-threshold-perc"] || constants.FILESYSTEM_SPACE_THRESHOLD_PERC;
                var percent = Number(s.block[0].percent[0]);
                var warn_space = percent > FILESYSTEM_SPACE_THRESHOLD_PERC;
                rv.push({
                    name: name,
                    percent: percent,
                    total: Number(s.block[0].total[0]),
                    usage: Number(s.block[0].usage[0]),
                    warn_space: warn_space,
                    status: true
                });
            }
        }
        catch (e) {
            console.error("Failed to extract filesystem data for service: " + (s.name ? s.name[0] : 'unknown'), e);
        }
    });
    return rv;
};
export var extractProgram = function (raw) {
    var rv = [];
    if (!raw.monit || !raw.monit.service)
        return rv;
    raw.monit.service.forEach(function (s) {
        try {
            if (s.$.type === "7") {
                rv.push({
                    name: s.name[0],
                    output: s.program ? s.program[0].output[0] : "!!empty!!",
                    // monit sets a non-zero status once an "if status != 0" test fails
                    status: !s.status || s.status[0] === "0"
                });
            }
        }
        catch (e) {
            console.error("Failed to extract program data for service: " + (s.name ? s.name[0] : 'unknown'), e);
        }
    });
    return rv;
};
export var getData = function () {
    return axios.post("/data")
        .then(function (r) { return r.data; })
        .then(function (r) {
        return r.map(function (x) {
            try {
                if (x.data) {
                    var system = extractSystem(x.data, x.overwrites);
                    var process = extractProcess(x.data, x.overwrites);
                    var filesystem = extractFilesystem(x.data, x.overwrites);
                    var program = extractProgram(x.data);
                    var warn = system.find(function (x) { return x.warn_cpu || x.warn_mem; }) !== undefined ||
                        process.find(function (x) { return x.pid && (x.warn_cpu || x.warn_mem || x.warn_uptime); }) !== undefined ||
                        filesystem.find(function (x) { return !x.status || x.warn_space; }) !== undefined;
                    var alert = process.find(function (x) { return !x.pid; }) !== undefined ||
                        program.find(function (x) { return !x.status; }) !== undefined;
                    return {
                        name: x.name,
                        status: true,
                        system: system,
                        process: process,
                        filesystem: filesystem,
                        program: program,
                        warn: warn,
                        alert: alert,
                        sort: alert ? 10 : (warn ? 5 : 1)
                    };
                }
            }
            catch (e) {
                console.error("Failed to parse data for " + x.name, e);
            }
            return {
                name: x.name,
                status: false,
                system: [],
                process: [],
                filesystem: [],
                program: [],
                warn: false,
                alert: true,
                sort: 20
            };
        });
    });
};
